import { LT_POS } from 'bl/loggers.bl';
import POS_READER_STATUS from 'constants/pos/posReaderStatus.const';
import mockJsonResponse from 'utils/backend/mockJsonResponse.util';
import { isEnvDev } from 'utils/env/determine.util';
import logger from 'utils/logger.util';

const L = logger(['MOCK/castor', LT_POS]); // eslint-disable-line no-unused-vars

const IS_ENABLED = false;

// ONLY mock while working locally, NEVER when deployed to some other environment
const define = (options, fn) => {
  if (!IS_ENABLED || !isEnvDev()) return void 1;

  const tag = options?.tag;
  L.debug('local()', tag, 'mocking...');

  return (...args) => {
    L.debug('local()', tag, 'calling with args:', args, '...');
    const result = fn(...args);
    L.debug('local()', tag, 'returning result:', result, '...');
    return result;
  };
};

const READER_STRIPE_ID = 'tmr_castor';
const LOCATION_STRIPE_ID = 'tml_castor';

const PERSISTENT_MUTABLE_READERS = [
  { status: POS_READER_STATUS.online, is_main: false },
  { status: POS_READER_STATUS.online, is_main: true },
  { status: POS_READER_STATUS.online, is_main: false },
  { status: POS_READER_STATUS.online, is_main: false },
].map((reader, index) => {
  const id = 100 * (10 + index) + (20 - index);
  return {
    ...reader,
    id,
    name: `Reader ${id}`,
    reader: READER_STRIPE_ID + id,
    location_id: LOCATION_STRIPE_ID + id,
    type: null,
    stylist: '',
    stylist_id: null,
  };
});

export const mock$beFindReaderV3 = define({ tag: 'castor step 1b beFindReaderV3' }, () => {
  // reverse in place i.e. the array is changed
  let id = 0;
  PERSISTENT_MUTABLE_READERS.reverse();
  for (const reader of PERSISTENT_MUTABLE_READERS) {
    id += 1;
    reader.id = id;
  }
  L.debug('mock$beFindReaderV3()', 'using readers:', PERSISTENT_MUTABLE_READERS);
  return mockJsonResponse({ body: { _v: 3, results: { readers: PERSISTENT_MUTABLE_READERS } } });
});

export const mock$beInitReaderPayment = define({ tag: 'castor step 2 beInitReaderPayment' }, () =>
  mockJsonResponse({
    body: {
      intent_id: 'pi_castor',
      client_secret: 'pi_castor_secret_castor-secret',
    },
  }),
);

export const mock$beGetPosIntentStatus = define({ tag: 'castor step 3 beGetPosIntentStatus' }, () =>
  mockJsonResponse({
    body: {
      message: 'Transaction deliberately failed to stop the flow from continuing',
      code: 'POS300',
      intent_id: 'pi_castor',
      reason: 'Because this flow is for checking only how multiple readers are being sorted',
    },
  }),
);
